import { AppProviders } from "@src/app/AppProviders";
import { NotFound, UnexpectedError } from "@src/components/widgets/ErrorPage";
import { createRootRoute, Outlet } from "@tanstack/react-router";

const RootComponent = () => (
  <AppProviders>
    <Outlet />
  </AppProviders>
);

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: UnexpectedError,
});
